import { IssueDetail, IssueSummary } from "models/issue";
import { ResolutionInfo } from "models/resolutions";
import { toEmailFieldName } from "features/Issues/helpers";
import { get } from "lodash";
import { Flex } from "@chakra-ui/react";
import { Text12 } from "components/Text";

export function missingChannelIssueType(_: IssueDetail) {
  return `Cannot Find Slack Channel`;
}

export function expandedMissingEmailIssueType(issue: IssueDetail) {
  return missingChannelIssueType(issue);
}

export function missingChannelValue(issue: IssueDetail) {
  const attribute = toEmailFieldName(issue?.context?.emailType);
  return get(issue?.user, attribute);
}

export function IssueModalInputFields({ issue }: { issue: IssueDetail }) {
  return (
    <Flex direction="column" gap="2">
      <Text12>{`You must go to Slack and add Camino to the channel ${issue?.messageServiceChannel?.name}`}</Text12>
    </Flex>
  );
}

export function missingChannelResolution(issue: IssueDetail | IssueSummary): ResolutionInfo {
  const channel = (issue as IssueDetail)?.messageServiceChannel;
  return ({
    issueType: "missing_channel_membership",
    tagText: `Cannot Find Slack Channel`,
    title: `Cannot find Slack Channel ${channel.name}`,

    additionalContext: `The Slack channel which we want to deliver a message to, cannot be found.`,
    inputComponent: IssueModalInputFields,
  });
}
